import { PaperQuestion } from './paper-question'
import { BlockTypeEnum } from './block-type-enum'

export interface PaperBlockInterface {
  /**
   * 关联的问题
   */
  questions?: PaperQuestion[]
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
  paperId: number
  parentId?: number
  type: BlockTypeEnum
  /**
   * hash
   */
  hash?: string
  /**
   * 题干 ID
   */
  questionId?: number
  questionIds?: number[]
  /**
   * 内容
   */
  content?: string
  /**
   * 附件
   */
  attachments?: object[]
  weight?: number
}

export class PaperBlock implements PaperBlockInterface {
  /**
   * 关联的问题
   */
  questions?: PaperQuestion[]
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
  paperId: number
  parentId?: number
  type: BlockTypeEnum
  /**
   * hash
   */
  hash?: string
  /**
   * 题干 ID
   */
  questionId?: number
  questionIds?: number[]
  /**
   * 内容
   */
  content?: string
  /**
   * 附件
   */
  attachments?: object[]
  weight?: number

  constructor(props: PaperBlockInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      questions: _questions,
      id: _id,
      schoolId: _schoolId,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      paperId: _paperId,
      parentId: _parentId,
      type: _type,
      hash: _hash,
      questionId: _questionId,
      questionIds: _questionIds,
      content: _content,
      attachments: _attachments,
      weight: _weight,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.questions = _questions
      ? _questions.map((i) => new PaperQuestion(i))
      : _questions
    this.id = _id
    this.schoolId = _schoolId
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
    this.paperId = _paperId
    this.parentId = _parentId
    this.type = _type
    this.hash = _hash
    this.questionId = _questionId
    this.questionIds = _questionIds
    this.content = _content
    this.attachments = _attachments
    this.weight = _weight
  }
}
